import { Stack } from '@mui/material';
import CardList from 'components/card-list/card-list.component';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ProductsList = props => {
  const { t } = useTranslation();
  const products = useWatch({ name: 'products' });

  return (
    <Stack spacing={1}>
      <CardList
        value={products.filter(product => product.category === 'ITEM')}
        label={t('drawer.addProductsDrawer.productTypes.items')}
        {...props}
      />
      <CardList
        value={products.filter(product => product.category === 'GROUP')}
        label={t('drawer.addProductsDrawer.productTypes.groups')}
        {...props}
      />
      <CardList
        value={products.filter(product =>
          ['MENU', 'CATALOG'].includes(product.category),
        )}
        label={t('drawer.addProductsDrawer.productTypes.menus')}
        {...props}
      />
    </Stack>
  );
};

export default ProductsList;
